var _path, _path2, _use, _path3, _use2, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJoinedPoints = function SvgJoinedPoints(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    baseProfile: "tiny",
    viewBox: "0 0 77.3 60",
    overflow: "visible"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3 50c0 4.5-3.5 8-7.7 8C5.5 58 2 54.5 2 50s3.5-8 7.7-8c4.1 0 7.6 3.5 7.6 8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7 60C4.3 60 0 55.5 0 50s4.3-10 9.7-10c5.3 0 9.7 4.5 9.7 10S15 60 9.7 60zm0-16C6.6 44 4 46.7 4 50s2.5 6 5.6 6 5.6-2.7 5.6-6c.1-3.3-2.4-6-5.5-6zm27-24c0 4.5-3.5 8-7.7 8s-7.7-3.5-7.7-8 3.5-8 7.7-8 7.7 3.5 7.7 8z"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8 40c0 4.5-3.5 8-7.7 8s-7.7-3.5-7.7-8 3.5-8 7.7-8 7.7 3.5 7.7 8z"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B",
    x: 24.2,
    y: 20
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3 10c0 4.5-3.5 8-7.7 8S60 14.5 60 10s3.5-8 7.7-8 7.6 3.5 7.6 8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7 20c-5.3 0-9.7-4.5-9.7-10s4.3-10 9.7-10 9.7 4.5 9.7 10-4.4 10-9.7 10zm0-16C64.6 4 62 6.7 62 10s2.5 6 5.6 6 5.6-2.7 5.6-6-2.4-6-5.5-6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4 51.1L8 48.9 28.5 17l24 19.8L65.9 9.1l3.6 1.8-15.6 32.3L29.5 23z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "B",
    d: "M29 30c-5.3 0-9.7-4.5-9.7-10s4.3-10 9.7-10 9.7 4.5 9.7 10-4.4 10-9.7 10zm0-16c-3.1 0-5.6 2.7-5.6 6s2.5 6 5.6 6 5.6-2.7 5.6-6-2.5-6-5.6-6z"
  }))));
};
export default SvgJoinedPoints;